module.exports = __webpack_public_path__ + "img/game_address_preview.4a509ab8.png";